import { createSlice } from "@reduxjs/toolkit";

const autoServiceValidationSlice = createSlice({
  name: "autoServiceValidationSlice",
  initialState: {
    autoValidation: false,
  },
  reducers: {
    enableAutoValidation: (state) => {
      state.autoValidation = true;
    },
    disableAutoValidation: (state) => {
      state.autoValidation = false;
    },
  },
});

export const { enableAutoValidation, disableAutoValidation } = autoServiceValidationSlice.actions;
export default autoServiceValidationSlice.reducer;
